<template>
  <div style="position: relative; width: 300px; margin: 0 auto; height: 260px" :class="classes">
    <c-img class="monitor" src="img/kb-screen.png" />
    <div :style="screenshotBackgroundStyle" class="screenshot-overlay" />
  </div>
</template>

<script>
export default {
  name: 'ModernMonitor',
  props: {
    screenshotUrl: String,
    classes: String,
  },
  computed: {
    screenshotBackgroundStyle() {
      return `background: url('${this.screenshotUrl}')`;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.monitor {
  position: absolute;
  width: 300px;
  left: 20px;
  z-index: 1;
  top: 0px;
}

.screenshot-overlay {
  height: 155px;
  width: 257px;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  position: absolute;
  top: 45px;
  left: 22px;
  //border: 3px solid black;
  background-position: center !important;
}
</style>
